module.exports = __webpack_public_path__ + "static/netflix3-bg-147c1bfb6206acca4f5e11c012b9964d.png";